var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTranslation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00022 0.928734C4.54279 0.928734 0.928955 4.54256 0.928955 9C0.928955 13.4574 4.54279 17.0713 9.00022 17.0713C13.4577 17.0713 17.0715 13.4574 17.0715 9C17.0715 4.54256 13.4577 0.928734 9.00022 0.928734Z",
    stroke: "#1890FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.928734C7.28418 0.928734 5.6709 4.54256 5.6709 9C5.6709 13.4574 7.28418 17.0713 9 17.0713C10.7158 17.0713 12.3291 13.4574 12.3291 9C12.3291 4.54256 10.7158 0.928734 9 0.928734Z",
    stroke: "#1890FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0715 9H0.928955",
    stroke: "#1890FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslation);
export default __webpack_public_path__ + "static/media/translation.fdd5acd4ead5a9152de75caf3dd1b180.svg";
export { ForwardRef as ReactComponent };